import { Fragment } from 'react';
import { BrowserRouter, Route, Routes,Navigate } from 'react-router-dom';

import AuthLayout from '../components/layout/auth';
import AdminLayout from '../components/layout/admin';
import AdminPrintLayout from '../components/layout/admin-print';

import Login from '../components/auth/login';
import LoginOtp from '../components/auth/login-otp';
import ForgotPassword from '../components/auth/forgot-password';
import FacilityUploadRecord from '../components/upload-record';
import DownloadRecord from '../components/download-record';

import AdminHome from '../components/admin/work-orders/active';
import AdminWorkOrderUnfinished from '../components/admin/work-orders-unfinished';
import AdminWorkOrder from '../components/admin/work-order-details';
import AdminWorkOrdersSearch from '../components/admin/work-orders-search';
import AdminWorkOrdersActive from '../components/admin/work-orders/active';
import AdminWorkOrdersClosed from '../components/admin/work-orders/closed';
import AdminWorkOrdersArchived from '../components/admin/work-orders/archived';
import AdminWorkOrdersCanceled from '../components/admin/work-orders/canceled';
//import AdminWorkOrdersRejected from '../components/admin/work-orders/rejected';


import AdminWorkOrdersIncomplete from '../components/admin/work-orders/incomplete';
import AdminWorkOrdersRecordsObtained from '../components/admin/work-orders/records-obtained'
import AdminWorkOrdersInvoiceNeeded from '../components/admin/work-orders/invoice-needed'
import AdminWoPrint from '../components/admin/work-order-details/wo-print';
import AdminCNRPrint from '../components/admin/work-order-details/cnr-print';
import AdminWorkOrdersMissing from '../components/admin/work-orders/missing'



import AdminInvoicePrint from '../components/admin/work-order-details/invoice-print';
import AdminAdministrators from '../components/admin/administrators'
import AdminPatients from '../components/admin/patients'
import AdminFacilities from '../components/admin/facilities'
import AdminClients from '../components/admin/clients'
import AdminCaseManagers from '../components/admin/case-managers'
import AdminReportsWorkOrdersClients from '../components/admin/reports/work-orders-clients'
import AdminReportsWorkOrdersFacilities from '../components/admin/reports/work-orders-facilities'
import AdminReportsWorkOrdersFacilitiesPrint from '../components/admin/reports/work-orders-facilities-pdf'

import AdminReportsTurnaround from '../components/admin/reports/turnaround'
import AdminReportsCost from '../components/admin/reports/average-cost-per-client'
import AdminReportsFacilityCost from '../components/admin/reports/average-cost-per-facility'
import AdminReportsOnHoldWOs from '../components/admin/reports/on-hold-wos'
import AdminReportsCanceledWOs from '../components/admin/reports/canceled-wos'
import AdminReportsRejectedWOs from '../components/admin/reports/rejected-wos'
import AdminReportsWeeklyWOs from '../components/admin/reports/weekly-wos'




import ClientLayout from '../components/layout/client';
import ClientPrintLayout from '../components/layout/client-print';



import ClientHome from '../components/client/home';
import ClientWorkOrderNew from '../components/client/work-orders-new';
import ClientWorkOrder from '../components/client/work-order';
import ClientWorkOrdersSearch from '../components/client/work-orders-search';
import ClientWorkOrdersClosed from '../components/client/home/closed';

import ClientWorkOrdersActive from '../components/client/home/active';
import ClientWorkOrdersIncomplete from '../components/client/home/incomplete';
import ClientWorkOrdersRecordsObtained from '../components/client/home/records-obtained'


import ClientInvoicePrint from '../components/client/work-order/invoice-print';
import ClientPatients from '../components/client/patients'
import ClientFacilities from '../components/client/facilities'
import ClientCaseManagers from '../components/client/case-managers'
import ClientReportsWorkOrdersClients from '../components/client/reports/work-orders-clients'

import ClientReportsTurnaround from '../components/client/reports/turnaround'









import CaseManagerLayout from '../components/layout/case-manager';
import CaseManagerPrintLayout from '../components/layout/case-manager-print';

import CaseManagerWorkOrdersActive from '../components/case-manager/home/active';
import CaseManagerWorkOrderNew from '../components/case-manager/work-orders-new';
import CaseManagerWorkOrder from '../components/case-manager/work-order';
import CaseManagerWorkOrdersSearch from '../components/case-manager/work-orders-search';
import CaseManagerWorkOrdersClosed from '../components/case-manager/home/closed';


import CaseManagerWorkOrdersIncomplete from '../components/case-manager/home/incomplete';
import CaseManagerWorkOrdersRecordsObtained from '../components/case-manager/home/records-obtained'

import CaseManagerPatients from '../components/case-manager/patients'

import CaseManagerReportsTurnaround from '../components/case-manager/reports/turnaround'
import CaseManagerReportsWorkOrdersCaseManagers from '../components/case-manager/reports/work-orders-case-managers'
import CaseManagerInvoicePrint from '../components/case-manager/work-order/invoice-print';





//import Dashboard from '../components/Dashboard';
import PageNotFound from '../components/pagenotfound';




const AllRoutes = () => {
    return (
        <Fragment>
            <BrowserRouter>
                <Routes>
                <Route path="/" exact element={<Navigate to="/login" />} />
                    <Route element={<AuthLayout />}>
                        <Route path="/"   >
                            <Route path="login" element={<Login />} />
                            <Route path="login-otp" element={<LoginOtp />} />
                            <Route path="forgot-password" element={<ForgotPassword />} /> 
                        </Route>
                    </Route>
                    <Route element={<AuthLayout />}>
                        <Route path="/"   >
                            <Route path="upload-record" element={<FacilityUploadRecord />} />     
                            <Route path="download-record" element={<DownloadRecord />} />                           
                      
                        </Route>
                    </Route>
                    <Route element={<AdminLayout />} >
                        <Route path="admin"   >
                            <Route path="home" element={<AdminHome />} />
                            <Route path="work-orders-new" element={<AdminWorkOrderUnfinished />} />
                            <Route path="work-order/:work_order_id?" element={<AdminWorkOrder />} />
                            <Route path="work-orders-search" element={<AdminWorkOrdersSearch />} />
                            <Route path="work-orders-active" element={<AdminWorkOrdersActive />} />
                            <Route path="work-orders-closed" element={<AdminWorkOrdersClosed />} />
                            <Route path="work-orders-archived" element={<AdminWorkOrdersArchived />} />
                            <Route path="work-orders-canceled" element={<AdminWorkOrdersCanceled />} />

                            <Route path="work-orders-incomplete" element={<AdminWorkOrdersIncomplete />} />
                            <Route path="work-orders-records-obtained" element={<AdminWorkOrdersRecordsObtained />} />
                            <Route path="work-orders-missing" element={<AdminWorkOrdersMissing />} />

                            <Route path="work-orders-invoice-needed" element={<AdminWorkOrdersInvoiceNeeded />} />

                            <Route path="administrators" element={<AdminAdministrators />} />
                            <Route path="patients" element={<AdminPatients />} />
                           
                            <Route path="facilities" element={<AdminFacilities />} />
                            <Route path="clients" element={<AdminClients />} />
                            <Route path="case-managers/:client_id?" element={<AdminCaseManagers />} />


                            <Route path="report-work-orders-client/:client_id?" element={<AdminReportsWorkOrdersClients />} />
                            <Route path="report-work-orders-facility/:facility_id?" element={<AdminReportsWorkOrdersFacilities />} />


                            <Route path="report-turnaround" element={<AdminReportsTurnaround />} />
                            <Route path="report-cost" element={<AdminReportsCost />} />
                            <Route path="report-facility-cost" element={<AdminReportsFacilityCost />} />

                            <Route path="report-on-hold" element={<AdminReportsOnHoldWOs />} />
                            <Route path="report-canceled" element={<AdminReportsCanceledWOs />} />
                            <Route path="report-weekly" element={<AdminReportsWeeklyWOs />} />


                        </Route>
                    </Route>
                    <Route element={<AdminPrintLayout />} >
                        <Route path="admin"   >
                            <Route path="invoice-print/:work_order_id" element={<AdminInvoicePrint />} />
                            <Route path="wo-print/:work_order_id" element={<AdminWoPrint />} />
                            <Route path="cnr-print/:work_order_id" element={<AdminCNRPrint />} />

                            <Route path="report-work-orders-facility-print/:facility_id?" element={<AdminReportsWorkOrdersFacilitiesPrint />} />

                        </Route>
                    </Route>




                    <Route element={<ClientPrintLayout />} >
                        <Route path="client"   >
                            <Route path="invoice-print/:work_order_id" element={<ClientInvoicePrint />} />

                        </Route>
                    </Route>


                    <Route element={<ClientLayout />} >
                        <Route path="client"   >
                            <Route path="home" element={<ClientHome />} />
                            <Route path="work-orders-new" element={<ClientWorkOrderNew />} />
                            <Route path="work-order/:work_order_id?" element={<ClientWorkOrder />} />
                            <Route path="work-orders-search" element={<ClientWorkOrdersSearch />} />
                            <Route path="work-orders-closed" element={<ClientWorkOrdersClosed />} />
                            <Route path="work-orders-active" element={<ClientWorkOrdersActive />} />

                            <Route path="work-orders-incomplete" element={<ClientWorkOrdersIncomplete />} />
                            <Route path="work-orders-records-obtained" element={<ClientWorkOrdersRecordsObtained />} />

                            <Route path="patients" element={<ClientPatients />} />
                           
                            <Route path="facilities" element={<ClientFacilities />} />
                            <Route path="case-managers/:client_id?" element={<ClientCaseManagers />} />

                            <Route path="report-work-orders-client/:client_id?" element={<ClientReportsWorkOrdersClients />} />
                            <Route path="report-turnaround" element={<ClientReportsTurnaround />} />

                        </Route>
                    </Route>



                   

                    <Route element={<CaseManagerPrintLayout />} >
                        <Route path="case-manager"   >
                            <Route path="invoice-print/:work_order_id" element={<CaseManagerInvoicePrint />} />

                        </Route>
                    </Route>

                
                    <Route element={<CaseManagerLayout />} >
                        <Route path="case-manager"   >
                            <Route path="work-orders-active" element={<CaseManagerWorkOrdersActive />} />
                            <Route path="work-orders-new" element={<CaseManagerWorkOrderNew />} />
                            <Route path="work-order/:work_order_id?" element={<CaseManagerWorkOrder />} />
                            <Route path="work-orders-search" element={<CaseManagerWorkOrdersSearch />} />
                            <Route path="work-orders-closed" element={<CaseManagerWorkOrdersClosed />} />

                            <Route path="work-orders-incomplete" element={<CaseManagerWorkOrdersIncomplete />} />
                            <Route path="work-orders-records-obtained" element={<CaseManagerWorkOrdersRecordsObtained />} />

                            <Route path="patients" element={<CaseManagerPatients />} />
                           
                         
                            <Route path="report-work-orders-case-manager/:case_manager_id?" element={<CaseManagerReportsWorkOrdersCaseManagers />} />
                            <Route path="report-turnaround" element={<CaseManagerReportsTurnaround />} />

                        </Route>
                    </Route>
                
                    <Route path="*" element={<PageNotFound />} />
                </Routes>
            </BrowserRouter>
        </Fragment>
    );

};

export default AllRoutes;
